import * as tagVideoActions from '../../action_creators/tag/tag_video_action_creators';
import TagVideoModel from '../../../models/tag/tag_video_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagVideoActions.tagVideoLoading({}, store));
    return TagVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(tagVideoActions.tagVideoLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(tagVideoActions.tagVideoLoadError(err, store));
        log.error(err, `Error in tag video actions, message: ${err.message}`);
      });
  };
}
